/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
} from 'reactstrap';
import {
  faDog,
  faPlus,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ClientDataComponent = ({
  clientData, editPet, toggleAddPetModal, toggleEditClient,
}) => (
  <>
    <Card outline color="secondary">
      <CardBody>
        <div className="d-flex justify-content-end">
          <FontAwesomeIcon
            style={{ textDecoration: 'none', cursor: 'pointer' }}
            onClick={() => { toggleEditClient(); }}
            icon={faEdit}
          />
        </div>
        <CardTitle>
          <div>
            Name :
            {' '}
            {clientData.name}
          </div>
          <div>
            Email (1) :
            {' '}
            {clientData.email1}
          </div>
          <div>
            Email (2) :
            {' '}
            {clientData.email2}
          </div>
          <div>
            Address :
            {' '}
            {clientData.address}
          </div>
          <div>
            Pincode :
            {' '}
            {clientData.pincode}
          </div>
          <div>
            City :
            {' '}
            {clientData.city}
          </div>
          <div>
            State :
            {' '}
            {clientData.state}
          </div>
          <div>
            Phone (R) :
            {' '}
            {clientData.phoneR}
          </div>
          <div>
            Phone (M1) :
            {' '}
            {clientData.phoneM1}
          </div>
          <div>
            Phone (M2) :
            {' '}
            {clientData.phoneM2}
          </div>
          <div>
            Owned Pets :
            {clientData.owned && clientData.owned.map((pet) => (
              // Redirect to home of clicked user with id
              <span style={{ paddingLeft: '5px' }} key={pet.value}>
                <Badge
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                  color="primary"
                  pill
                  onClick={() => { editPet(pet.value); }}
                >
                  {pet.label}
                </Badge>
              </span>
            ))}
            <span style={{ paddingLeft: '5px' }}>
              <Badge
                color="warning"
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                pill
                onClick={() => { toggleAddPetModal(); }}
              >
                <FontAwesomeIcon icon={faPlus} />
                {' '}
                <FontAwesomeIcon icon={faDog} />
              </Badge>
            </span>
          </div>
        </CardTitle>
      </CardBody>
    </Card>
  </>
);

export default ClientDataComponent;
